module.exports = __webpack_public_path__ + "img/ta_askfor_result.c9446d24.png";